import React from "react";
import heroImage from "../../assets/images/home/webp/leftParrotWithPoy.webp";
import HeroSectionForm from "./HeroSectionForm";

function HeroSection() {
  return (
    <div className="flex flex-col lg:flex-row w-full lg:gap-20 lg:justify-between lg:pb-5">
      {/* Container for Title, Mobile Form, and Content */}
      <div className="flex flex-col pt-6 lg:pt-[20px]">
        {/* 1. TITLE: First on mobile, stays top-left on desktop */}
        <h2 className="order-1 lg:max-w-[700px] text-[32px] leading-[40px] lg:text-[52px] text-[#00487A] lg:leading-[72px] font-bold pl-6 lg:pl-[120px]">
          The People have Spoken -{" "}
          <span className="text-[#FB7C2F]">Crowned Product of the Year</span>
        </h2>

        {/* 2. FORM (Mobile Only): Shows second on mobile, hidden on desktop */}
        <div className="order-2 mt-6 lg:hidden">
          <HeroSectionForm />
        </div>

        {/* 3. IMAGE & TEXT: Third on mobile, stays under title on desktop */}
        <div className="order-3 flex flex-col-reverse lg:flex-row">
          <img
            src={heroImage}
            alt="hero"
            className="my-6 lg:my-0 lg:w-[415px] self-center lg:h-[595px] w-[363px] h-[509px]"
          />
          <p className="pt-4 px-6 lg:ml-10 lg:px-0 text-[#4D4D4D] lg:max-w-[336px] lg:pt-6">
            Presenting ManipalCigna Sarvah Health Insurance, truly complete
            health insurance solution, now crowned Product of the Year 2025,
            that offers you an Essential Shield, Infinite Power and Instant
            Peace. This plan has 3 variants ManipalCigna{" "}
            <span className="font-bold text-[#FB7C2F]">Pratham, Uttam</span> and{" "}
            <span className="font-bold text-[#FB7C2F]">Param</span> each
            tailored to provide the infinite coverage, infinite security and
            infinite power.
            <br />
            <span className="lg:px-0 text-[#4D4D4D] text-[12px] lg:max-w-[336px] lg:pt-6">
              (Winner Health Insurance Category. Survey of 1800 people by
              NielsenIQ across categories.)
            </span>
          </p>
        </div>
      </div>

      {/* 4. FORM (Desktop Only): Hidden on mobile, appears on the right side for desktop */}
      <div className="hidden lg:block mt-4">
        <HeroSectionForm />
      </div>
    </div>
  );
}

export default HeroSection;
